export default {
  vehicles: {
    vehicles: [],
    pagination: {
      page: 1,
      limit: 10,
      total: 0,
      pages: 0,
      prev: null,
      next: null
    }
  },
  currentPage : 1
}
